<template>
  <div class="modal fade" id="PaymentRunLogs" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="PaymentRunLogsLabel">Logs</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                                    <span class="fa-stack fa-2x fsm float-right">
                                        <i class="far fa-circle fa-stack-2x"></i>
                                        <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                    </span>
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <div class="table-responsive-lg tfh">
                  <b-table striped :items="log" :fields="PaymentRunLogsFields" :busy="log===null">
                    <template v-slot:table-busy>
                      <b-row align-h="center">
                        <propagate-loader class="mb-3" :color="primaryColour" :size="16"></propagate-loader>
                      </b-row>
                    </template>
                    <template slot="Level" slot-scope="data">
                      <div
                        v-if="data.item.Level == 'Warning'"
                        class="bg-warning position-absolute brll"
                      >
                        <p class="fwfont font-weight-bold">{{data.item.Level}}</p>
                      </div>
                      <div
                        v-else-if="data.item.Level == 'Problem'"
                        class="bg-d position-absolute brll"
                      >
                        <p class="fwfont font-weight-bold">{{data.item.Level}}</p>
                      </div>
                      <div v-else>
                        <p class="fwfont font-weight-bold">{{data.item.Level}}</p>
                      </div>
                    </template>
                    <template slot="LoggedAt" slot-scope="data">{{data.item.LoggedAt | shortDate()}}</template>
                    <template slot="Reference" slot-scope="data">{{data.item.Reference}}</template>
                    <template slot="Details" slot-scope="data">
                      <p class="font-weight-bold d-inline">Message:</p>
                      <p style="white-space: pre-wrap;">{{data.item.Message}}</p>
                      <p class="font-weight-bold d-inline">Guidance:</p>
                      <p style="white-space: pre-wrap;">{{data.item.Guidance}}</p>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import moment from "moment";
import Vue from "vue";
import _filters from "@/mixins/filters.js";

export default {
  mixins: [_filters],
  data() {
    return {
      PaymentRunLogsFields: {
        Level: {
          label: "Level",
          class: "text-center position-relative no-pad"
        },
        LoggedAt: {
          label: "Logged At",
          class: "text-center"
        },
        Reference: {
          label: "Reference",
          class: "text-center"
        },
        Details: {
          Message: {
            label: "Message",
            class: "text-center"
          },
          Guidance: {
            label: "Guidance",
            class: "text-center"
          }
        }
      }
    };
  },
  computed: {
    primaryColour() {
      return Vue.config.honeycomb.theme;
    },
    log() {
      return this.$store.state.finances.paymentLogs;
    },
    details() {
      return this.$store.state.finances.runDetails;
    }
  }
};
</script>